import * as React from "react";
import { forwardRef } from "react";
const SvgArrowLeft = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M8.25 14.25L4.11615 9.92803C3.62795 9.41761 3.62795 8.58239 4.11615 8.07197L8.25 3.75M14.25 14.25L10.1162 9.92803C9.62795 9.41761 9.62795 8.58239 10.1162 8.07197L14.25 3.75", stroke: "#595E6A", strokeWidth: 1.2, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgArrowLeft);
export default ForwardRef;
